$ = require 'jquery'
Alerts = undefined
queueRequire -> Alerts = require 'views/lib/alerts'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
ApplicationView = undefined
queueRequire -> ApplicationView = require 'views/application-view'
AttachmentViewer = undefined
queueRequire -> AttachmentViewer = require 'views/internal/attachment-viewer'
Auth = require 'db/auth'
Backbone = require 'backbone'
Board = undefined
queueRequire -> Board = require 'models/board'
BoardView = undefined
queueRequire -> BoardView = require 'views/board/board-view'
Dialog = undefined
queueRequire -> Dialog = require 'views/lib/dialog'
EventsMixin = require 'lib/events-mixin'
FavIcon = undefined
queueRequire -> FavIcon = require 'lib/favicon'
Hearsay = require 'hearsay'
JoinOnConfirm = undefined
queueRequire -> JoinOnConfirm = require 'lib/join-on-confirm'
Keys = require 'data/keys'
LastOrganization = require 'lib/last-organization'
Member = undefined
queueRequire -> Member = require 'models/member'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Notification = undefined
queueRequire -> Notification = require 'models/notification'
Organization = undefined
queueRequire -> Organization = require 'models/organization'
PluginModal = undefined
queueRequire -> PluginModal = require 'views/lib/plugin-modal'
PopOver = undefined
queueRequire -> PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
rpc = undefined
queueRequire -> rpc = require 'network/rpc'
SearchState = undefined
queueRequire -> SearchState = require 'view-models/search-state'
SidebarState = undefined
queueRequire -> SidebarState = require 'view-models/sidebar-state'
simpleTest = require 'lib/experiments/simple-test'
logError = require 'debug/log-error'
track = require 'debug/track'
Util = require 'lib/util'
UserInput = require 'views/internal/user-input'
_ = require 'underscore'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
l = require 'lib/localize'
ldclient = require 'lib/ldclient'
assert = require 'lib/assert'
f = require 'effing'
ApiError = require 'network/api-error'
xtend = require 'xtend'
getWebContext = require 'debug/get-web-context'
getExperiment = require 'lib/experiments/simple-test'
Interceptor = require('singlespa/interceptor').default

# This is extremely fragile. But these history errors are driving me insane.
# If we ever get a reasonable router -- and some day we may -- then we won't
# need this nonsense. But in the meantime, this prevents incredibly annoying
# bugs like this one:
#
# 1. Open the notifications tab and click a link to a board (not in a comment
#    or anything; in notification text).
# 2. Press the back button.
# 3. Get into an infinite redirect loop.
# 4. Swear off Trello forever.
#
# Feel free to extend this; this only handles the very common cases and is
# nowhere near exhaustive.

shortLinker = (prefix) ->
  ///^ / #{Util.escapeForRegex prefix} / ([a-zA-Z0-9]{8}) (/|$) ///

getCardShortLink = (route) ->
  shortLinker('c').exec(route)?[1]

getBoardShortLink = (route) ->
  shortLinker('b').exec(route)?[1]

nonEmptyAndEqual = (str1, str2) -> str1 && str2 && str1 == str2

isTheSameAs = (route1, route2) ->
  card1 = getCardShortLink(route1)
  card2 = getCardShortLink(route2)
  if nonEmptyAndEqual card1, card2
    return true

  board1 = getBoardShortLink(route1)
  board2 = getBoardShortLink(route2)
  if nonEmptyAndEqual board1, board2
    return true

  return false

headerLoad = (methodName, eventName) ->
  actualLoad = if Auth.isLoggedIn()
    ModelLoader.for('header', methodName)
  else
    Promise.resolve(null)

  actualLoad.then ->
    ModelLoader.triggerWaits(eventName)
  .catch ApiError, (err) ->
    logError new Error("headerLoad ApiError, err = #{err}, err.constructor.name = #{err.constructor.name}")
    throw err
  .catch ApiError.Unauthenticated, (err) ->
    # We've previously tried logging people out when they get an unauthorized error,
    # while loading the header, under the assumption that they've somehow got a bad cookie.
    # Unfortunately we've had some firefox users reporting that this is logging them out
    # when it shouldn't be
    console.log("Error trying to load header")
  .done()

getQueryParams = ->
  queryString = window.location.search
  _.chain(queryString.substring(1).split('&'))
    .map (param) -> param.split('=')
    .object()
    .value()

getQueryParamByKey = (key) -> getQueryParams()[key]

iframeSource = getQueryParamByKey('iframeSource')

getPathWithIframeSource = (path, iframeSource) ->
  if /\?[^=]+\=[^&]+/.test(path) # check for existing query parameters
    return "#{path}&iframeSource=#{iframeSource}"
  else
    return "#{path}?iframeSource=#{iframeSource}"


mixin EventsMixin, class Controller extends Backbone.Router
  initialize: ->
    @_savedTitle = ""
    @currentModel = new Hearsay.Slot(null)
    # We're a singleton; this should last forever
    @currentModel.use()

  getQueryParamByKey: getQueryParamByKey

  start: ->
    rpc.on 'subscription_unauthorized', (modelType, idModel) =>
      shouldDisplayError = switch modelType
        when 'Board' then @onBoardView(idModel)
        when 'Organization' then @onOrganizationView(idModel)
        else false

      if shouldDisplayError
        errorType = if modelType == 'Board'
            "boardNotFound"
          else
            "notFound"

        @displayErrorPage({ errorType })

    headerLoad 'loadHeaderData', 'headerData'
    setTimeout f(headerLoad, 'loadBoardsMenuData', 'boardsData'), 500

    if Auth.isLoggedIn()
      ModelLoader.await('headerData')
      .then ->
        Auth.me().loadNextSurveyDate()
        # LaunchDarkly - Once we have the header data
        # we can send a more informative user object to LD
        ldclient.updateUserInfo()
      .done()

    UserInput.addHandler
      shortcut: (key) =>
        if key == Keys.QuestionMark
          if @onAnyBoardView()
            @navigate('shortcuts/overlay')
            @shortcutsViewOverlay()
          else
            @navigate '/shortcuts', trigger: true
          "Shortcuts page"
    , scope: 'global'

    JoinOnConfirm.autoJoin()
    .then (didJoin) ->
      if didJoin
        # We can't trust that the stuff that we quickloaded is
        # going to be accurate, or that we'll catch the updates
        # when we subscribe, so just dump it to be safe
        QuickLoad.clear()
    .return()

  viewType: 'none'

  topLevelView: (viewType, model, options) ->
    @applicationView ?= new ApplicationView()
    options ?= {}
    options.modelCache ?= @getCurrentModelCache()
    @applicationView.subview(viewType, model, options)

  existingTopLevelView: (viewType, model) ->
    @applicationView.existingSubview(viewType, model)

  existingTopLevelViewOrUndefined: (viewType, model) ->
    @applicationView?.existingSubviewOrUndefined(viewType, model)

  title: (title) ->
    if title?
      @_savedTitle = title

    me = Auth.me()
    unreadNotifications = me?.unreadNotifications()

    unreadCount = unreadNotifications.count
    unreadString = if unreadCount then "* " else ""
    fullTitle = unreadString
    if @_savedTitle?.length > 0
      fullTitle += "#{ @_savedTitle } | "
    fullTitle += "Trello"

    # If someone happens to be using fluid, update their dockBadge
    # http://fluidapp.com/developer/
    window.fluid?.dockBadge = (if unreadNotifications.displayCount then unreadNotifications.displayCount else null)

    FavIcon.setNotifications(unreadCount > 0)
    document.title = fullTitle

  setLocation: ({ title, location, options }) ->
    if title?
      @title(title)

    if location
      if /^#/.test(location)
        location = location.substr(1)

      @navigate(location, options)
      @location = location
    return

  showingCalendar: (boardView) ->
    boardView?.$('.calendar-wrapper').length > 0

  setBoardLocation: (idBoard, section = '', extra = [], options) ->
    name = ModelCache.get('Board', idBoard).get('name')
    @setLocation(
      title: name
      location: @getBoardUrl(idBoard, section, extra)
      options: options
    )
    return

  saveMemberBoardProfileLocation: (member, idBoard) ->
    @setLocation
      title: member.get('fullName')
      location: @getMemberBoardProfileUrl(member.get('username'), idBoard)

  isOnSearchPage: -> @currentPage == 'search'

  onAnyOrganizationView: -> @currentModel.get() instanceof Organization
  onOrganizationView: (idOrganization) -> @onAnyOrganizationView() && @currentModel.get().id == idOrganization

  onAnyBoardView: -> @currentModel.get() instanceof Board
  onBoardView: (idBoardOrShortLink) ->
    if @onAnyBoardView()
      if Util.checkId(idBoardOrShortLink)
        @currentModel.get().id == idBoardOrShortLink
      else if Util.isShortLink(idBoardOrShortLink)
        @currentModel.get().get('shortLink') == idBoardOrShortLink
    else
      false

  onHome: -> @currentPage == 'home'

  # This is gross, but slightly better than having a global 'boardView' variable
  getCurrentBoardView: ->
    @existingTopLevelViewOrUndefined(BoardView, @getCurrentBoard())

  getCurrentBoard: ->
    if @onAnyBoardView()
      @currentModel.get()
    else
      null

  getCurrentOrganization: ->
    model = @currentModel.get()
    if model?
      switch model.typeName
        when 'Organization'
          model
        when 'Board'
          model.getOrganization() ? LastOrganization.NO_ORGANIZATION
        else
          null
    else
      null

  getCurrentModelCache: -> @currentModelCache

  saveBoardsView: ->
    if @savedBoardViewInformation? || !@onAnyBoardView()
      return

    @savedBoardViewInformation =
      idBoard: @currentModel.get().id
      path: /// /b/[^/]*/(.*) ///.exec(@location)[1]
    return

  loadBoardsView: ->
    if !@savedBoardViewInformation
      return

    { idBoard, path } = @savedBoardViewInformation

    @boardView idBoard, path

    delete @savedBoardViewInformation

  clearPreviousView: (shallow) ->
    # shallow = true is for singlespa page transitions
    if shallow
      SearchState.setQuery("")
      PopOver.hide()
      PluginModal.close()
      if Dialog.isVisible
        Dialog.hide(true)

      return

    SearchState.setQuery("")
    @applicationView?.remove()
    delete @applicationView
    PopOver.hide()
    PluginModal.close()
    if Dialog.isVisible
      Dialog.hide(true)
    $('#content').html('')
    $('body')
    .scrollTop('0')
    $('#classic-body')
    .removeClass('body-single-column body-tabbed-page body-search-page
      body-board-view body-custom-board-background
      body-custom-board-background-tiled body-light-board-background
      body-dark-board-background body-default-header body-hide-header')
    .css
      'background-image': ''
      'background-color': ''
      AttachmentViewer.clear()
    return

  # Call this *after* loading data, before displaying
  # (So the transition is instant)
  setViewType: (modelOrString) ->
    if @currentModel.get() instanceof Board
      @currentModel.get().markAsViewed()

    if _.isString(modelOrString)
      @currentModelCache = ModelCache
      @currentModel.set null
    else
      @currentModelCache = modelOrString.modelCache
      @currentModel.set modelOrString
    @currentPage = modelOrString

    if @currentModel.get() instanceof Board
      board = @currentModel.get()
      @waitForId board, ->
        # [MARK AS VIEWED]
        board.markAsViewed()
        SidebarState.pushBoard(board.id)
    else
      FavIcon.setBackground({ useDefault: true })

    return

  onCardView: ->
    # Hey look! We're duplicating code. In actually the *third* place.
    # isWebClientPage has this check, it's defined in the route above,
    # and we have it here too.
    # Turns out Backbone's router gives you *no* inspection ability. It
    # doesn't return any routes that you create. The method that converts
    # routes into regular expressions is private. Even if you create a named
    # route, there's no way to retrive the Backbone route object for that.
    # So! When we stop using Backbone's router, make sure to come back and
    # fix this.
    ///^ c/ [a-zA-Z0-9]{8} (/[^/]+)? ///.test Backbone.history.fragment

  organizationById: (idOrganization) ->
    ModelLoader.for 'top-level', 'loadOrgNameById', idOrganization
    .then (name) =>
      @organizationBoardsView(name)
    .catch ApiError, =>
      @displayErrorPage()
    .done()

  getSpinner: ->
    $('.header-logo').addClass('is-throbbing')
    Promise.resolve().disposer ->
      $('.header-logo').removeClass('is-throbbing')
      Interceptor.hideGamma()
      return

  syncError: (err) ->
    Alerts.showHtml(templates.fill('sync_error'), 'error', 'modelSync')
    if !@_reportedError
      @_reportedError = true

      # We get back an error message that will contain something like
      # "ixSinceUpdate too high: 2 > 1 (...id...)"
      # "ixSinceUpdate too low. 1 < 2 (...id...)"
      parts = /too (low|high)[\.:]\s+(\d+)\s[<>]\s(\d+)/.exec(err.message) || []
      [all, lowOrHigh, value1, value2] = parts

      track('Error', 'Sync Error',
        if rpc.isUsingSocket() then "Using Socket" else "Using AJAX",
        if parts? then (if lowOrHigh == 'high' then 'Too High' else 'Too Low') else "Unknown",
        # The difference between the two values that came back in the error message,
        # so we have a sense of how far past the queue length we were
        if parts? then Math.abs(parseInt(value1, 10) - parseInt(value2, 10))
      )

      timeSinceGoodConnection = Date.now() - (rpc.rpcCurrent.dateLastMessage || 0)

      $.ajax({
        url: "/test-connection"
        timeout: 3000
      })
      .fail =>
        track('Error', 'Sync Error Connectability', 'Unreachable', undefined, timeSinceGoodConnection)
      .done =>
        track('Error', 'Sync Error Connectability', 'Reachable', undefined, timeSinceGoodConnection)
    return

  focusContent: ->
    # Focus the content, so it can immediately be scrolled
    # with the arrow keys.  The tabindex is necessary
    # to make the div focusable.
    $('#content').attr('tabindex', -1).focus()

navigate = Backbone.History::navigate

trackPageview = (fragment) ->
  if fragment == ''
    fragment = 'boards'

  window.ga? 'send', 'pageview', "/#{fragment}"
  window.sp? 'trackPageView:cf', null, getWebContext()

_.extend Backbone.History.prototype,
  navigate: (path, options) ->
    if iframeSource?
      path = getPathWithIframeSource(path, iframeSource)

    if isTheSameAs(path, @location.pathname)
      options = xtend options, { replace: true }

    interceptorPath = path
    if interceptorPath[0] != '/'
      interceptorPath = '/' + interceptorPath

    if interceptorPath.indexOf('/confirm-email') < 0 && Auth.isLoggedIn() && !Auth.confirmed() && getExperiment('confirmDuringSignup').get('enabled')
      search = "?confirmReturnUrl=#{encodeURIComponent(interceptorPath)}"

      return @navigate '/confirm-email' + search, { trigger: true }
    else if Interceptor.isGammaRoute(interceptorPath)
      Interceptor.navigateToGamma(interceptorPath)
      trackPageview(path)
    else
      navigate.call(this, path, options)
      if options?.replace || (!options?.trigger && !options?.replace)
        trackPageview(path)

    return

components = [
  require './display-board'
  require './urls'
  require './header'
  require './footer'
  require './quick-boards'
  require './other-routes'
  require './invitation-routes'
  require './board-routes'
  require './user-or-org-routes'
  require './enterprise-routes'
  require './member-routes'
  require './organization-routes'
  require './catchall-route'
]

routes = _.chain components
.map (component) ->
  _.extend Controller.prototype, component
  delete Controller.prototype.routes
  component.routes
.compact()
.flatten(true)
.value()
.reverse() # https://github.com/jashkenas/backbone/issues/1463

singleton = new Controller()
Interceptor.setController(singleton)
routes.forEach ([route, name]) ->
  singleton.route route, name
module.exports = singleton

singleton.on("route", (route, params) ->
 # Set NewRelic route names to the Backbone ones
 newrelic.setCurrentRouteName(route)
)

# [MARK AS VIEWED]
#
# The right thing to do would be to have all this accounting-for-
# views code observe the current location of the Controller, instead
# of having the Controller know about that much. A good project
# for a future refactor.



// WEBPACK FOOTER //
// ./app/scripts/controller/index.coffee